import { User } from "firebase/auth";
import nookies from "nookies";

import coreAPI from "@/datasources/coreAPI";
import { fetchMyUser, updateProfilePicture } from "@/lib/api";
import { UserType } from "@/types/api";

export const cookieOptions = {
  path: "/",
  // for security and preventing CSRF attacks
  sameSite: true,
};

const setCookies = (name: string, value: string, options?: any) => {
  nookies.destroy(null, name);
  nookies.set(null, name, value, options);
};

export const idTokenChangedCallback = async (
  authUser: User | null
): Promise<UserType | null> => {
  // Setting and unsetting the token in cookies
  if (!authUser || !authUser.email) {
    nookies.destroy(null, "bxtoken", cookieOptions);
    nookies.destroy(null, "email", cookieOptions);
    nookies.destroy(null, "firstName", cookieOptions);
    nookies.destroy(null, "userId", cookieOptions);

    return null;
  }

  const token = await authUser.getIdToken();
  setCookies("bxtoken", token, cookieOptions);
  coreAPI.setToken(token);

  const user = await fetchMyUser();

  if (
    !!authUser?.photoURL &&
    // Explicit null/undefined check as empty string indicates user does not want a profile picture
    (user.profilePictureUrl === null || user.profilePictureUrl === undefined)
  ) {
    // Get better resolution image
    const photoUrl = authUser.photoURL.replace("=s96-c", "=s800-c");
    await updateProfilePicture(user, photoUrl);
    user.profilePictureUrl = photoUrl;
  }

  return user;
};
